export default __webpack_public_path__ + "static/media/file-upload.c4269bbb.gif";